import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { RegistroEntrenador, RegistroEntrenadorJSON } from './RegistroEntrenador';

export class RegistroEntrenadorSystem {
    private readonly base = '/registroentrenadores';
    constructor(private requestHandler: XhrRequestHandler) {
    }

    async getRegistroEntrenadorIdentifiedBy(id: string): Promise<RegistroEntrenador> {
        const data = await this.requestHandler.get<RegistroEntrenadorJSON>(`${this.base}/${id}`);
        return RegistroEntrenador.fromJSON(data);
    }

    async getList(): Promise<RegistroEntrenador[]> {
        const data = await this.requestHandler.get<RegistroEntrenadorJSON[]>(`${this.base}`);
        return data.map((entity) => RegistroEntrenador.fromJSON(entity))
    }

    async getListForDropdown(): Promise<RegistroEntrenador[]> {
        const data = await this.requestHandler.get<RegistroEntrenadorJSON[]>(`${this.base}/for-dropdown`);
        return data.map((entity) => RegistroEntrenador.fromJSON(entity))
    }

    async getListForAutocomplete(searchKey: string): Promise<RegistroEntrenador[]> {
        const data = await this.requestHandler.get<RegistroEntrenadorJSON[]>(`${this.base}/for-autocomplete?searchKey=${searchKey}`);
        return data.map((entity) => RegistroEntrenador.fromJSON(entity));
    }

    async save(entity: RegistroEntrenador, token: string) {
        const registroEntrenadorData = entity.toJSON();
        var bodyFormData = new FormData();
        bodyFormData.append('registroEntrenador', JSON.stringify(registroEntrenadorData));
        bodyFormData.append('token', token);
        if (entity.getDocumentoImagen()) bodyFormData.append('documento', entity.getDocumentoImagen()!);
        if (entity.getFoto()) bodyFormData.append('selfie', entity.getFoto()!);

        entity.getRegistroEntrenadorTituloList().forEach((titulo, idx) => {
            if (titulo.getImagenTitulo()) {
                bodyFormData.append('tituloImg_' + idx, titulo.getImagenTitulo()!);
            }
        });

        const data = await this.requestHandler.postWithFormData<unknown>(this.base + '/save', bodyFormData);
        // return RegistroEntrenador.fromJSON(data);
        return data;
    }

    // async save(registroEntrenador: RegistroEntrenador, fileDocumento: File | null, fileSelfie: File | null, token: string) {
    //   var bodyFormData = new FormData();
    //   if (fileDocumento) bodyFormData.append('documento', fileDocumento);
    //   if (fileSelfie) bodyFormData.append('selfie', fileSelfie);
    //   bodyFormData.append('registroEntrenador', JSON.stringify(registroEntrenador.toJSON()));
    //   bodyFormData.append('token', token);

    //   const data = await this.requestHandler.postWithFormData<unknown>(`registroentrenadors/save`, bodyFormData);
    //   return data;
    // }

    getBaseUrlForDatagrid() {
        return this.requestHandler.requestUrl(`${this.base}/datagrid`)
    }

    async checkEntrenadorExisteByDni(dni: string): Promise<any> {
        const data = await this.requestHandler.get<boolean>(`${this.base}/existe-entrenador-por-dni/${dni}`);
        return data;
    }

    async checkRegistroEntrenadorExisteByDni(dni: string): Promise<any> {
        const data = await this.requestHandler.get<boolean>(`${this.base}/existe-registro-entrenador-por-dni/${dni}`);
        return data;
    }

    async confirmarRegistracion(token: string): Promise<any> {
      const data = await this.requestHandler.get<RegistroEntrenadorJSON>(`${this.base}/confirm-registration/${token}`);
      return data;
  }

}

